import { Site } from '@envato/foundation-types'

import { getConfigBySite } from '../../config/sites'
import CategoryPageContainer from './categoryPageContainer'
import SearchPageContainer from './searchPageContainer'
import { selectItemCountForCategory } from '../../common/selectors/categories'
import {
  hasSearchPageQueryParams,
  getSearchLocationParams
} from '../../common/utils/location'
import { ILocationParams, IQuery } from '../../common/utils/location/types'
import pageProxyContainer, {
  MapStateToPageComponent
} from './pageProxyContainer/pageProxyContainer'

const getSiteSpecificConfig = (currentSite: Site) => ({
  minItemCountForCategoryPage: getConfigBySite(
    currentSite,
    'minimum_items_for_category_page'
  ),
  isCategoryPageEnabled: getConfigBySite(currentSite, 'displayCategoryPage'),
  categoriesWithForcedSearchPage: getConfigBySite(
    currentSite,
    'categories_with_forced_search_page'
  )
})

export const chooseContainer = ({
  currentSite,
  query,
  locationParams,
  itemCount
}: {
  currentSite: Site
  query: IQuery
  locationParams: ILocationParams
  itemCount: number
}) => {
  const {
    minItemCountForCategoryPage,
    isCategoryPageEnabled,
    categoriesWithForcedSearchPage
  } = getSiteSpecificConfig(currentSite)

  const shouldForceSearchPage = categoriesWithForcedSearchPage.some(
    (category: string) =>
      locationParams.category && locationParams.category.startsWith(category)
  )

  if (isCategoryPageEnabled && !shouldForceSearchPage) {
    if (hasSearchPageQueryParams(query)) {
      return 'SearchPageContainer'
    } else if (
      !locationParams.category ||
      itemCount > minItemCountForCategoryPage
    ) {
      return 'CategoryPageContainer'
    } else {
      return 'SearchPageContainer'
    }
  }
  return 'SearchPageContainer'
}

const containers = {
  CategoryPageContainer,
  SearchPageContainer
}

const mapStateToPageComponent: MapStateToPageComponent = (
  state,
  routeMatch
) => {
  const {
    experiments,
    common: { currentSite },
    router: { location }
  } = state

  const locationParams = getSearchLocationParams({
    location,
    routeMatch,
    currentSite,
    experiments
  })

  const itemCount = selectItemCountForCategory(state, locationParams.category)

  const choosenContainer = chooseContainer({
    currentSite,
    query: location.query,
    locationParams,
    itemCount
  })

  return containers[choosenContainer]
}

const CategoryProxyContainer = pageProxyContainer(mapStateToPageComponent)

export default CategoryProxyContainer
